export const CHART_DARK_FORE_COLOR = '#fff'
export const CHART_DARK_GRID_COLOR = '#fff'

export function isDarkChartTheme(store) {
  return store?.state?.appConfig?.layout?.skin === 'dark'
}

function mergeAxisTitle(title, color) {
  return {
    ...(title || {}),
    style: {
      color,
      ...(title?.style || {}),
    },
  }
}

function mergeAxisLabels(labels, color) {
  return {
    ...(labels || {}),
    style: {
      colors: color,
      ...(labels?.style || {}),
    },
  }
}

function applyDarkYaxis(yaxis, color) {
  if (Array.isArray(yaxis)) {
    return yaxis.map((axis) => applyDarkYaxis(axis, color))
  }

  return {
    ...(yaxis || {}),
    labels: mergeAxisLabels(yaxis?.labels, color),
    title: mergeAxisTitle(yaxis?.title, color),
  }
}

export function applyChartDarkTheme(options, isDark, chartType = '') {
  if (!isDark || !options || typeof options !== 'object') {
    return options
  }

  const color = CHART_DARK_FORE_COLOR
  const themed = {
    ...options,
    theme: {
      mode: 'dark',
      ...(options.theme || {}),
    },
    chart: {
      ...(options.chart || {}),
      foreColor: color,
    },
    grid: {
      ...(options.grid || {}),
      borderColor: CHART_DARK_GRID_COLOR,
    },
    legend: {
      ...(options.legend || {}),
      labels: {
        colors: color,
        ...(options.legend?.labels || {}),
      },
    },
  }

  if (options.xaxis) {
    themed.xaxis = {
      ...options.xaxis,
      labels: mergeAxisLabels(options.xaxis.labels, color),
      title: mergeAxisTitle(options.xaxis.title, color),
    }
  }

  if (options.yaxis !== undefined) {
    themed.yaxis = applyDarkYaxis(options.yaxis, color)
  }

  if (chartType !== 'pie') {
    themed.dataLabels = {
      ...(options.dataLabels || {}),
      style: {
        colors: [color],
        ...(options.dataLabels?.style || {}),
      },
    }
  }

  return themed
}
